import Repository from '@/services/Repository';

const resource = '/schools';

export default {
  fetchOne(schoolId) {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/${schoolId}`)
        .then((response) => {
          let { data } = response;
          data.id = data._id;
          try {
            resolve(data);
          } catch (error) {
            console.error(error);
            reject(error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update(editingSchool) {
    return Repository.put(`${resource}/${editingSchool.id}`, editingSchool);
  },
};
